export default {
  user_type: {
    administrator: {
      key: 'administrator',
      label: 'Administrator',
    },
    manager: {
      key: 'manager',
      label: 'Manager',
    },
    vendor: {
      key: 'vendor',
      label: 'Vendor',
    },
    worker: {
      key: 'worker',
      label: 'Worker',
    },
  },
};
